type RoomAudioStarter = {
  startAudio: () => Promise<void>;
};

export type RoomAudioStartResult = { ok: true } | { ok: false; error: Error };

export async function startRoomAudioPlayback(
  room: RoomAudioStarter
): Promise<RoomAudioStartResult> {
  try {
    await room.startAudio();
    return { ok: true };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
}
